

export default {
  table_check:[],  // 表格屏蔽列
  siteConfig: {},  // 站点配置（来自后台 tb_setting）
}


// WEBPACK FOOTER //
// ./src/store/state.js